import React from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

// project imports
import Avatar from "@stories/ui-component/extended/Avatar";
import { ProjectLineItem } from "@interfaces/project";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { ContractorPackageLineItem } from "@interfaces/contractorPackage";
import { NoRows } from "@stories/molecules/ListTable/NoRows";
import { DataLoadingRow } from "@stories/molecules/ListTable/DataLoadingRow";
import EditIcon from "@mui/icons-material/Edit";
interface ContractorPackageTableProps {
  loading: boolean;
  project: ProjectLineItem;
  contractorPackages: ContractorPackageLineItem[];
  handleOpen: () => void;
  handleViewPackage: (contractorPackage: ContractorPackageLineItem) => void;
  handleEditPackage: (contractorPackage: ContractorPackageLineItem) => void;
  handleReportDownload: (contractorPackage: ContractorPackageLineItem) => void;

  handleDeletePackage: (contractorPackage: ContractorPackageLineItem) => void;
}

export const ContractorPackageTable = ({
  loading,
  contractorPackages,
  handleViewPackage,
  handleEditPackage,
  handleReportDownload,
  handleDeletePackage,
}: ContractorPackageTableProps) => {
  const theme = useTheme();
  const handleRowClick = (contractorPackage: ContractorPackageLineItem) => {
    handleViewPackage(contractorPackage);
  };

  return (
    <StyledCard>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sub Contractor Name</TableCell>
              <TableCell>Package Value</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contractorPackages &&
              contractorPackages.map((row, index) => (
                <TableRow hover key={index}>
                  <TableCell onClick={() => handleRowClick(row)}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <Avatar
                          alt={row.contractorName}
                          src={row.contractorLogo}
                        />
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Typography
                          align="left"
                          variant="subtitle1"
                          component="div"
                        >
                          {row.contractorName}
                        </Typography>
                        <Typography align="left" variant="subtitle2" noWrap>
                          {`${row.created.toLocaleDateString()}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                  <TableCell onClick={() => handleRowClick(row)}>
                    {`$ ${row.totalPackageValue.toLocaleString()}`}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick(row)}>
                    {row.startDate.toLocaleDateString()}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick(row)}>
                    {row.endDate.toLocaleDateString()}
                  </TableCell>
                  <TableCell align="center" sx={{ pr: 3 }}>
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Tooltip placement="top" title="Edit">
                        <IconButton
                          color="primary"
                          sx={{
                            color: theme.palette.info.dark,
                            borderColor: theme.palette.info.main,
                            "&:hover ": {
                              background: theme.palette.info.light,
                            },
                          }}
                          size="large"
                          onClick={() => handleEditPackage(row)}
                        >
                          <EditIcon sx={{ fontSize: "1.1rem" }} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          {contractorPackages.length === 0 && !loading ? (
            <NoRows colSpan={5} title={"Packages"} />
          ) : null}
          {loading && <DataLoadingRow colSpan={5} />}
        </Table>
      </TableContainer>
    </StyledCard>
  );
};
